import React from 'react';
import PropTypes from 'prop-types';

import { PricingStyled } from './Pricing.styled';

const Pricing = ({
  cents, value, label, modifiers,
}) => (
  <PricingStyled modifiers={modifiers}>
    <strong>
      <sup>$ </sup>{value}
      {cents && <span>.{cents}</span>}
    </strong>
    <small>{label}</small>
  </PricingStyled>
);

Pricing.propTypes = {
  value: PropTypes.node,
  label: PropTypes.string,
  modifiers: PropTypes.oneOf(['', 'medium']),
};

Pricing.defaultProps = {
  value: '',
  label: '',
  modifiers: '',
};

export default Pricing;
